/**
 * Currency configuration — single source of truth for frontend
 * Synced with CurrencySupport::ALL_CURRENCIES (Ruby)
 *
 * NOTE: 收款功能目前只支援 TWD（綠界金流），
 *       但格式化顯示支援所有幣別。
 */
export const CURRENCY_CONFIG = {
  TWD: { symbol: 'NT$', precision: 0 },
  USD: { symbol: '$', precision: 2 },
  JPY: { symbol: '¥', precision: 0 },
  CNY: { symbol: '¥', precision: 2 },
  AUD: { symbol: 'A$', precision: 2 },
  EUR: { symbol: '€', precision: 2 }
};

/**
 * Format currency amount with symbol
 *
 * @param {number} amount - The amount to format
 * @param {string} currency - Currency code (TWD, USD, etc.)
 * @returns {string} Formatted currency string
 */
export function formatCurrency(amount, currency = 'TWD') {
  const config = CURRENCY_CONFIG[currency] || CURRENCY_CONFIG.TWD;
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : (amount || 0);
  const formattedAmount = (isNaN(numericAmount) ? 0 : numericAmount).toLocaleString('en-US', {
    minimumFractionDigits: config.precision,
    maximumFractionDigits: config.precision
  });

  return `${config.symbol}${formattedAmount}`;
}

/**
 * Format currency range
 *
 * @param {number} min - Minimum amount
 * @param {number} max - Maximum amount
 * @param {string} currency - Currency code
 * @returns {string} Formatted range string
 */
export function formatCurrencyRange(min, max, currency = 'TWD') {
  if (min === max) {
    return formatCurrency(min, currency);
  }
  return `${formatCurrency(min, currency)} - ${formatCurrency(max, currency)}`;
}

/**
 * Format fee range with "+" suffix when no max
 *
 * @param {number} minFee - Minimum fee
 * @param {number} maxFee - Maximum fee (optional)
 * @param {string} currency - Currency code
 * @returns {string} Formatted range string (e.g., "NT$1,000 - NT$2,000" or "NT$1,000+")
 */
export function formatFeeRange(minFee, maxFee, currency = 'TWD') {
  const min = formatCurrency(minFee, currency);

  if (maxFee && maxFee > minFee) {
    const max = formatCurrency(maxFee, currency);
    return `${min} - ${max}`;
  }

  return `${min}+`;
}
